import {  AxiosError, AxiosRequestConfig } from "axios";
import { IAxiosRetryConfig } from "axios-retry";
import * as Sentry from "@sentry/react";
// status codes range examples:
// [[400],[404]] will retry only for 400 and 404 status codes
// [[400-422],[500] will retry for status codes in range from 400 to 422 and single 500 status codes.
const STATUS_CODES_TO_RETRY = [[500,599]];
const RETRY_DELAY = 1000;

const axiosRetryConfig : IAxiosRetryConfig = {
    retries: 3,
    retryDelay: (retryCount: number) => {
        return retryCount * RETRY_DELAY;
    },
    onRetry: (retryCount: number, error: AxiosError, requestConfig: AxiosRequestConfig) => {
        console.log(`Retry attempt ${retryCount}, on error: ${error.message}`);
        sendSentryErrorMessage(error, retryCount);
    },
    retryCondition: (error: AxiosError) => {
        if (error.code === 'ERR_NETWORK') {
            return true;
        }
        if (checkStatusCode(error.response?.status)) {
            console.log('Retry by status code: ' + error.response?.status)
            return true;
        }
        return false;
    }
}

const checkStatusCode = (statusCode?: number) => {
    for (const range of STATUS_CODES_TO_RETRY) {
        if (statusCode && checkRange(range, statusCode)) {
            return true;
        }
    }
    return false;
}

const checkRange = (range: number[], statusCode: number) => {
    if(range.length === 1) {
        return (statusCode === range[0])
    }
    return (statusCode >= range[0] && statusCode <= range[1])
}

const sendSentryErrorMessage = (error: AxiosError, retryAttempt: number) => {
    Sentry.captureException(new Error(`Request error: ${error.request?.__sentry_xhr__?.method} ${error.request?.__sentry_xhr__?.url}, retry attempt ${retryAttempt}`))
}

export  { axiosRetryConfig }